import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';

import { Navigate } from "react-router-dom";

import MainLayout from './Component/Layout/MainLayout';
import Dashboard from './Component/Pages/Dashboard/Dashboard';
import User from './Component/Pages/User/User';
import PushNotification from './Component/Pages/PushNotification/Pushnotification';
import AdminProfile from './Component/Pages/AdminProfile/Adminprofile';
import Subscription from './Component/Pages/Subscription/Subscription';
import Login from './Component/Login/Login';

import ProtectedRoute from "./Component/ProtectedRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ✅ Login */}
        <Route path="/" element={<Login />} />

        {/* ✅ Protected Layout */}
        <Route element={
          // <ProtectedRoute>
            <MainLayout />
          // </ProtectedRoute>
        }>

          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/notifications" element={<PushNotification />} />
          <Route path="/users" element={<User />} />
          <Route path="/profile" element={<AdminProfile />} />

        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;